/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { isEmpty } from 'lodash';
import { Pagination } from 'swiper/modules';
import {
  DwtcVAApplicationProcessWrapper,
  DwtcVAApplicationProcessDesktopWrapper,
  DwtcVAApplicationProcessHeader,
  DwtcVAApplicationProcessHeaderTitle,
  DwtcVAApplicationProcessHeaderText,
  DwtcVAApplicationProcessBody,
  SwiperSlideCard,
  SwiperSlideCardTextWrapper,
  SwiperSlideCardSubtitle,
  SwiperSlideCardtitle,
  SwiperSlideCardText,
  DwtcVAApplicationProcessDisclamier,
  DWTCVASliderButton,
  PrevButton,
  NextButton,
} from '../styles/DwtcVAApplicationProcess.styled';
import Sprites from '../Sprites';

export default function DwtcVAApplicationProcessDesktop({ data, dir }) {
  const [currIndex, setCurrIndex] = React.useState(0);
  const [swiper, setSwiper] = React.useState(null);
  const [initialSlide, setInitialSlide] = React.useState(0);
  const handleClickNext = () => swiper?.slideNext();
  const handleClickPrev = () => swiper?.slidePrev();
  const breakpoints = {
    0: {
      slidesPerView: 1.2,
      centeredSlides: false,
      spaceBetween: 0,
    },
    576: {
      slidesPerView: 1.8,
      centeredSlides: false,
    },
    767: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 0,
    },
    1280: {
      slidesPerView: 6,
      centeredSlides: false,
      spaceBetween: 0,
    },
  };
  return (
    <DwtcVAApplicationProcessWrapper>
      <DwtcVAApplicationProcessDesktopWrapper>
        <DwtcVAApplicationProcessHeader>
          <DwtcVAApplicationProcessHeaderTitle>{data.title}</DwtcVAApplicationProcessHeaderTitle>
          <DwtcVAApplicationProcessHeaderText>{data.text}</DwtcVAApplicationProcessHeaderText>
        </DwtcVAApplicationProcessHeader>
        <DwtcVAApplicationProcessBody dir={dir}>
          <Swiper
            pagination={{
              clickable: true,
            }}
            onSwiper={setSwiper}
            modules={[Pagination]}
            breakpoints={breakpoints}
            spaceBetween={0}
            initialSlide={initialSlide}
            slideToClickedSlide
            onClick={(_swiper) => setCurrIndex(_swiper.clickedIndex)}
            onSlideChange={(_swiper) => {
              setCurrIndex(_swiper.activeIndex);
            }}
            className="mySwiper"
          >
            {isEmpty(data.dwtcVAApplicationProcessList) ||
              data.dwtcVAApplicationProcessList.map((item, index) => (
                <SwiperSlide key={index}>
                  <SwiperSlideCard className="slider-card">
                    <SwiperSlideCardSubtitle className="card-number" dir={dir}>
                      <span>{item.content.subtitle}</span>
                    </SwiperSlideCardSubtitle>
                    <SwiperSlideCardTextWrapper dir={dir} className="card-text-wrapper">
                      <SwiperSlideCardtitle dir={dir}>{item.content.title}</SwiperSlideCardtitle>
                      <SwiperSlideCardText
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: item.content.text }}
                      />
                    </SwiperSlideCardTextWrapper>
                  </SwiperSlideCard>
                </SwiperSlide>
              ))}
          </Swiper>
          <DWTCVASliderButton>
            <PrevButton
              type="button"
              onClick={handleClickPrev}
              style={{ opacity: currIndex === 0 ? 0.5 : 1 }}
            >
              <Sprites name="arrowprev" />
            </PrevButton>
            <NextButton
              type="button"
              onClick={handleClickNext}
              style={{
                opacity: currIndex === data.dwtcVAApplicationProcessList.length - 1 ? 0.5 : 1,
              }}
            >
              <Sprites name="arrownext" />
            </NextButton>
          </DWTCVASliderButton>
          <DwtcVAApplicationProcessDisclamier
            dangerouslySetInnerHTML={{ __html: data.vaDisclaimer }}
          />
        </DwtcVAApplicationProcessBody>
      </DwtcVAApplicationProcessDesktopWrapper>
    </DwtcVAApplicationProcessWrapper>
  );
}
